import { useSearchParams } from 'react-router-dom';
import { TitleBar, Footer } from '../../../components';
import TableV3 from '../../../components/generic/Table/TableV3';
import TitleUpdater from '../../../components/common/TitleUpdater';
import QueryErrorBoundary from '../../../components/error-handling';
import { useQualitativeFactorItApplicationSummary } from '../hooks/useQualitativeFactorItApplicationSummary';
import { useLocationName } from '../../../hooks';
import { columns } from '../columns/reports-columns';

const QUALITATIVE_FACTORS = 'Qualitative Factor';

export const CyberHubQualitativeFactorsReport = () => {
  const [searchParams] = useSearchParams();
  const locationUuid = searchParams.get('location');

  const { locationName } = useLocationName(locationUuid ?? undefined);

  const { data, loading, error } = useQualitativeFactorItApplicationSummary(
    locationUuid ?? undefined,
  );

  const title = `${
    data?.length ? `${data.length} ` : ''
  }${QUALITATIVE_FACTORS}s`;

  const subtitle = `${
    !locationName ? `All Enterprise` : `${locationName}`
  } ${QUALITATIVE_FACTORS}s`;

  return (
    <>
      <TitleUpdater
        title={`${
          locationName ? locationName : 'Enterprise'
        } ${QUALITATIVE_FACTORS} Report`}
      />
      <TitleBar title={`${QUALITATIVE_FACTORS} Report`} subtitle={subtitle} />
      <QueryErrorBoundary>
        <TableV3
          title={title}
          data={data}
          columns={columns(QUALITATIVE_FACTORS)}
          loading={loading}
          error={error}
          rowKey="uuid"
        />
      </QueryErrorBoundary>
      <Footer goBack />
    </>
  );
};
